import { Link, useParams, useSearchParams } from "react-router-dom";
import { getTitleCase } from "../../../utils/utilityFunctions/stringUtility";
import { ReactComponent as TaskIconSvg } from "../../../assets/images/task-icon.svg";
import { ReactComponent as NotesIconSvg } from "../../../assets/images/notes-icon.svg";
import { ReactComponent as DocumentIconSvg } from "../../../assets/images/document-icon.svg";

const SubmoduleNav = ({ items = [], subTabValue, onSelect = () => {}, disableRouting }) => {
  const { id: customerId, tab: tabValue } = useParams();
  const [searchParams] = useSearchParams();

  const NAVMENU_ICON = {
    notes: <NotesIconSvg />,
    tasks: <TaskIconSvg />,
    documents: <DocumentIconSvg />,
  };

  if (!items?.length) return null;

  // ----- Back Button Conditions -----
  const firstItem = items[0];
  const showBack = subTabValue !== firstItem?.value;

  // return <div>HH</div>
  return (
    <div className="flex items-center gap-1">
      {/* BACK BUTTON */}
      {/* {showBack &&
        (disableRouting && onSelect ? (
          <button
            onClick={() => onSelect(firstItem)}
            className="flex items-center gap-2 transition-all cursor-pointer text-gray-600 bg-white"
          >
            <ArrowCircleLeftIcon />
          </button>
        ) : (
          <Link
            to={`/customer/${customerId}/${tabValue}/${firstItem.value}`}
            className="flex items-center gap-2 rounded-full transition-all cursor-pointer text-gray-400 bg-white"
          >
            <ArrowCircleLeftIcon />
          </Link>
        ))} */}

      <div className="flex bg-white border-[1px] border-gray-200 rounded-full p-1">
        {console.log("SubmoduleNavitem", items)}
        {items?.map((item, index) => {
          if (index === 0) return;
          const isActive = item.value === subTabValue;
          const label = getTitleCase(item.label) || item.label;

          const baseClasses = "flex items-center gap-2 rounded-full px-3 py-0.5 text-sm transition-all cursor-pointer";
          const activeClasses = "border border-primary text-primary bg-white font-semibold shadow-sm";
          const inactiveClasses = "text-[#777] hover:border-primary hover:text-primary";

          const cls = `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`;

          const content = (
            <div className="flex items-center gap-2">
              <span>{NAVMENU_ICON[item?.label?.toLowerCase()]}</span>
              <span>
                {label}
                {item.count !== undefined && ` (${item.count})`}
              </span>
            </div>
          );

          if (disableRouting && onSelect) {
            return (
              <button key={item?.value} onClick={() => onSelect(item)} className={cls}>
                {content}
              </button>
            );
          }

          return (
            <div key={item.value} onClick={() => onSelect(item.label)} className={cls}>
              {content}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SubmoduleNav;
